// extracted by mini-css-extract-plugin
export default {"container":"FullImagePreview_container__Kbaqf","header":"FullImagePreview_header__DvOVz","controls":"FullImagePreview_controls__qyxhb","image":"FullImagePreview_image__XW7x0"};